import { create } from "zustand";

import {
  NotificationConfirmProps,
  NotificationConfirmUpdateProps,
} from "../components/NotificationConfirm";

export type DialogProps = {
  title: string;
  type: "success" | "error" | "info";
  description?: string;
  details?: string[];
};

type NotificationStore = {
  dialog?: DialogProps;
  confirm?: NotificationConfirmProps;
  showDialog: (dialog: DialogProps) => void;
  closeDialog: () => void;
  showConfirm: (config: NotificationConfirmProps) => void;
  updateConfirm: (config: NotificationConfirmUpdateProps) => void;
  closeConfirm: () => void;
};

const useNotificationStore = create<NotificationStore>()((set, get) => ({
  dialog: undefined,
  confirm: undefined,

  showDialog: (dialog: DialogProps) => {
    set({ dialog });
  },
  closeDialog: () => {
    set({ dialog: undefined });
  },

  showConfirm: (confirm: NotificationConfirmProps) => {
    set({ confirm });
  },
  updateConfirm: (configChanges: NotificationConfirmUpdateProps) => {
    const current = get().confirm;
    if (!current) {
      return;
    }

    set({
      confirm: {
        ...current,
        ...configChanges,
      },
    });
  },
  closeConfirm: () => {
    set({ confirm: undefined });
  },
}));

export default useNotificationStore;
